__turbopack_context__.v({
  "loginLink": "_4bkdW_loginLink",
  "quizSignupDivider": "_4bkdW_quizSignupDivider",
  "signupGateContainer": "_4bkdW_signupGateContainer",
  "signupGateContent": "_4bkdW_signupGateContent",
});
